import React from 'react';
import Icon from "../Icon";
import {Link} from "react-router-dom";

const CardTitle = (props) => {
    const iconBg = `card-icon p-2 bg-opacity-25 rounded-2${props.iconBgColor ? ' bg-' + props.iconBgColor : ' bg-dark'}`;
    const classes = `d-flex align-items-start gap-3${props.className ? ' ' + props.className : ''}`;

    return (
        <div className={classes}>
            {props.icon && <div className={iconBg}>
                <Icon name={props.icon}
                      width="30px"
                      fill={props.iconBgColor === "light" ? props.iconBgColor : null}/>
            </div>
            }
            <div>
                {props.title && <h6 className="card-title fw-semibold lh-base mb-0 text-nowrap">{props.title}</h6>}
                {props.subTitle && <p className="card-subtitle m-0 fs-xs fw-medium opacity-75">{props.subTitle}</p>}
            </div>

            {props.link && <div className="w-100 text-end">
                <Link to={props.link} className="text-primary text-md">
                    <Icon name="view_timeline" width={24} fill="gray"/>
                </Link>
            </div>}
        </div>
    );
};

export default CardTitle;

